<template>
  <label
    :for="forTag"
    class="block"
  >
    <span v-html="label"></span>
    <span
      class="required"
      v-if="required"
    >
      *
    </span>
  </label>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "FormLabelComponent",
    props: {
      forTag: {
        type: String,
        required: true
      },
      label: {
        type: String,
        default: ""
      },
      required: {
        type: Boolean,
        default: false
      }
    }
  });
</script>
